import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Button,
} from '@material-ui/core';

/**
 * @param {{
 *  isOpen: boolean,
 *  setIsOpen: (value: boolean) => void,
 *  onConfirm: () => void,
 *  isLocked: boolean,
 * }} param0
 * @returns
 */
function LockAwardingConfirmation({
    isOpen = false, setIsOpen = () => {}, onConfirm = () => {}, isLocked,
}) {
    const { t } = useTranslation('shiftBidding');
    return (
        <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
        >
            <>
                <DialogTitle>
                    {
                        isLocked
                            ? t('employee.summary.modal.protectAssignedShiftline.titleUnlock')
                            : t('employee.summary.modal.protectAssignedShiftline.titleLock')
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {
                            isLocked
                                ? t('employee.summary.modal.protectAssignedShiftline.contentUnlock')
                                : t('employee.summary.modal.protectAssignedShiftline.contentLock')
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => setIsOpen(false)}
                    >
                        {t('employee.common.no')}
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onConfirm}
                    >
                        {t('employee.common.yes')}
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    );
}

export default LockAwardingConfirmation;
